import { clientRecords, invoicingEntityApi } from '@atheneum/api'
import { extendObservable, action, computed } from 'mobx'

class InvoicingStore {
  constructor (staticData, growlStore) {
    extendObservable(this, {
      loading: false,
      error: null,
      invoicingEntities: [],
      invoicingEntitiesCount: null,
      staticData,
      growlStore,
      parentAccountId: null,
      timezone: computed(() => {
        if (!this.invoicingEntity) return ''
        const timezoneId = this.invoicingEntity.address.timezoneId
        return this.staticData.names.timezones[timezoneId]
      }),
      invoicingRegion: null,
      query: this.defaultSearchQuery()
    })
  }

  defaultSearchQuery = () => {
    return {
      parentAccountId: null,
      legalName: '',
      glCode: '',
      country: ''
    }
  }

  clearSearch = parentAccountId => {
    this.query = this.defaultSearchQuery()
    this.query.parentAccountId = parentAccountId
  }

  loadInvoicingEntities = parentAccountId => {
    this.loading = true
    this.query = this.defaultSearchQuery()
    this.parentAccountId = parentAccountId
    this.query.parentAccountId = parentAccountId
    clientRecords
      .getInvoicingEntities(parentAccountId)
      .then(res => {
        const formattedInvoices = res.rows.map(invoice => {
          const countryId = invoice.address.countryId
          const country = this.staticData.names.countries[countryId]
          return { ...invoice, country }
        })
        this.invoicingEntities.replace(formattedInvoices)
        this.invoicingEntitiesCount = res.count
      })
      .catch(err => {
        this.error = err
      })
      .then(() => {
        this.loading = false
      })
  }

  filter = () => {
    this.loading = true
    invoicingEntityApi
      .search(this.query)
      .then(res => {
        const formattedInvoices = res.rows.map(invoice => {
          const countryId = invoice.address.countryId
          const country = this.staticData.names.countries[countryId]
          return { ...invoice, country }
        })
        this.invoicingEntities.replace(formattedInvoices)
        this.invoicingEntitiesCount = res.count
      })
      .catch(err => {
        this.error = err
      })
      .then(() => {
        this.loading = false
      })
  }

  deleteInvoicingEntity = action(invoiceId => {
    return invoicingEntityApi
      .deleteInvoicingEntity(invoiceId)
      .then(() => {
        const afterDelete = this.invoicingEntities.filter(
          entity => entity.id !== invoiceId
        )
        this.invoicingEntities.replace(afterDelete)
      })
      .catch(err => {
        this.error = err
        this.growlStore.showError(err)

        throw err
      })
  })
}

export default InvoicingStore
